const state = () => ({
    showStatus: false, // 各详情页是否显示审批状态
    projectOptions: '', // 项目映射 形式[{ text: '天地图智慧系统', value: '1' },{ text: '测试项目申请', value: '1986408092100018178' },{ text: '撒旦', value: '1986410379862163458' },]
    newProjectOptions: '', // 项目映射 形式 { "1": "天地图智慧系统","1986408092100018178": "测试项目申请","1986410379862163458": "撒旦",}
    carOptions: '',
    newCarOptions: '',
})
const getters = {}
const mutations = {
    setShowStatus(state,value){
        state.showStatus = value
    },
    setProjectOptions(state,value){
        state.projectOptions = value
    },
    setNewProjectOptions(state,value){
        state.newProjectOptions = value
    },
    setCarOptions(state,value){
        state.carOptions = value
    },
    setNewCarOptions(state,value){
        state.newCarOptions = value
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
}
